import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Container, Row, Col, Form } from "react-bootstrap";

const CheckoutOrderNote: React.FC<IProps> = (
  {
    setNote
  }: IProps) => {
  return (
    <S.Wrapper defaultActiveKey="0">
      <S.CheckoutOrderNoteCard>
        <S.CheckoutOrderNoteCardHeader>
          <S.CheckoutOrderNoteCardHeaderTitle eventKey="0">
            Order Note
          </S.CheckoutOrderNoteCardHeaderTitle>
        </S.CheckoutOrderNoteCardHeader>
        <S.CheckoutOrderNoteCardCollapse eventKey="0">
          <S.CheckoutOrderNoteCardBody>
            <Container>
              <Row>
                <Col>
                  <Form.Control
                    onChange={(e: any) => {
                      setNote(e.target.value)
                    }}
                    as="textarea" rows={5}
                  />
                </Col>
              </Row>
            </Container>
          </S.CheckoutOrderNoteCardBody>
        </S.CheckoutOrderNoteCardCollapse>
      </S.CheckoutOrderNoteCard>
    </S.Wrapper>
  )
};

export { CheckoutOrderNote }